import React, { useState, useContext, useRef, useEffect } from 'react';
import axios from 'axios';
import ProgressBar from 'react-bootstrap/ProgressBar';
import DatePicker from 'react-datepicker';
import LoadingSpinnerImage from '../TaskManagerApp/LoadingSpinnerImage';
import { datePopperConfig } from "../Shared/datePopperConfig.js";


const MultipleFileUpload = ({ context, showPDFOnly = false, allowMultiple = true }) => {

    const AppContext = useContext(context);

    const [debug, setDebug] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedValidFiles, setSelectedValidFiles] = useState([]);
    const [startedUploading, setStartedUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [warningMessage, setWarningMessage] = useState('');
    const maxUploadFiles = 10; // 0 for no limit
    const allowedExtensions = ['.pdf', '.ris'];
    const [selectedOption, setSelectedOption] = useState(showPDFOnly ? "pdf" : "manual");
    const [addReferenceTitle, setAddReferenceTitle] = useState("");
    const [addReferenceAbstract, setAddReferenceAbstract] = useState("");
    const [addReferenceAuthors, setAddReferenceAuthors] = useState("");
    const [addReferenceJournal, setAddReferenceJournal] = useState("");
    const [addReferenceSource, setAddReferenceSource] = useState("");
    const [addReferenceYear, setAddReferenceYear] = useState("");
    const [addReferenceDOI, setAddReferenceDOI] = useState("");
    const [addReferenceURL, setAddReferenceURL] = useState("");
    const [addReferencePublicationType, setAddReferencePublicationType] = useState("");
    const [addReferencePublicationDate, setAddReferencePublicationDate] = useState("");
    const [addReferenceKeywords, setAddReferenceKeywords] = useState("");
    const [addReferenceLanguage, setAddReferenceLanguage] = useState("");
    const [addReferenceVolume, setAddReferenceVolume] = useState("");
    const [addReferenceIssue, setAddReferenceIssue] = useState("");
    const [addReferencePages, setAddReferencePages] = useState("");
    const [addReferenceISSN, setAddReferenceISSN] = useState("");
    const [isAddingReference, setIsAddingReference] = useState(false);
    const [addReferenceError, setAddReferenceError] = useState(false);
    const [errorAddReferenceTitle, setErrorAddReferenceTitle] = useState(false);
    const [errorAddReferenceAbstract, setErrorAddReferenceAbstract] = useState(false);
    const [errorAddReferenceAuthors, setErrorAddReferenceAuthors] = useState(false);
    const [errorAddReferenceSource, setErrorAddReferenceSource] = useState(false);
    const [errorAddReferenceDOI, setErrorAddReferenceDOI] = useState(false);
    const [errorAddReferenceURL, setErrorAddReferenceURL] = useState(false);
    const [errorAddReferenceYear, setErrorAddReferenceYear] = useState(false);
    const [errorAddReferencePublicationDate, setErrorAddReferencePublicationDate] = useState(false);
    const [errorAddReferenceKeywords, setErrorAddReferenceKeywords] = useState(false);
    const [errorAddReferenceLanguage, setErrorAddReferenceLanguage] = useState(false);
    const [errorAddReferenceVolume, setErrorAddReferenceVolume] = useState(false);
    const [errorAddReferenceIssue, setErrorAddReferenceIssue] = useState(false);
    const [errorAddReferencePages, setErrorAddReferencePages] = useState(false);
    const [errorAddReferenceISSN, setErrorAddReferenceISSN] = useState(false);
    const [errorAddReferenceJournal, setErrorAddReferenceJournal] = useState(false);
    const [errorAddReferencePublicationType, setErrorAddReferencePublicationType] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [concludedUploads, setConcludedUploads] = useState(0);
    const [showCloseAndRefreshListButton, setShowCloseAndRefreshListButton] = useState(false);

    const [searchDOI, setSearchDOI] = useState("");
    const [isSearchingInfoForDOI, setIsSearchingInfoForDOI] = useState(false);
    const [errorGettingDOIInfo, setErrorGettingDOIInfo] = useState(false);
    const [uploadResults, setUploadResults] = useState(null);
    const [invalidFilesSelected, setInvalidFilesSelected] = useState(false);

    const pdfFileInputRef = useRef(null);
    const risFileInputRef = useRef(null);




    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        let validFiles = files;
        setStartedUploading(false);
        setInvalidFilesSelected(false);
        setSelectedValidFiles([]);
        setSelectedFiles([]);

        // Validate file type
        if (allowedExtensions.length) {
            validFiles = files.filter(file =>
                allowedExtensions.includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())
            );
        }


        // Is the correct extension on all files for the selected tab? (pdf/ris)
        let validExtension = selectedOption == "pdf" ? ".pdf" : ".ris";
        const invalidFiles = files.filter((file) => !file.name.toLowerCase().endsWith(validExtension));
        if (invalidFiles.length) {
            setInvalidFilesSelected(true);
            return;
        }



        setSelectedValidFiles(validFiles);

        setWarningMessage('');
        if (validFiles.length != files.length) {
            let allow = "";
            allowedExtensions.map((item, index) => { allow += (index > 0 ? (index == allowedExtensions.length - 1 ? " and " : ", ") : "") + "*" + item });
            setWarningMessage('Some files will not be uploaded. Valid files are ' + allow);
        }


        // Validate file count
        if (validFiles.length <= maxUploadFiles && maxUploadFiles > 0) {
            setSelectedFiles(validFiles);
            setUploadProgress(Array(validFiles.length).fill(0));
            setErrorMessage('');
        } else {
            setSelectedFiles([]);
            setUploadProgress([]);
            setErrorMessage('You can only upload a maximum of ' + maxUploadFiles + ' files simultaneously.');
        }



    };


    const uploadFile = async (file, index, filetype) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post(
                `/umbraco/api/ReferenceManager/Upload?importType=${filetype}&referenceId=${showPDFOnly ? AppContext.currentReference.Id : ""
                }`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: ({ loaded, total }) => {
                        const progress = Math.round((loaded * 100) / total);

                        setUploadProgress(prev => {
                            const next = [...prev];
                            next[index] = progress;
                            return next;
                        });
                    }
                }
            );

            setConcludedUploads(prev => prev + 1);

            let data = response.data;

            // Fix for pdfs not sending Results as array (ris do)
            if (!Array.isArray(data.Results))
                data.Results = data.Results ? [data.Results] : [];

            return data;

        } catch (error) {
            setConcludedUploads(prev => prev + 1);

            return {
                Success: false,
                FileName: file.name,
                Results: [
                    {
                        Success: false,
                        ReferenceId: null,
                        Status: -1,
                        Message:
                            error.response?.data?.message ||
                            error.message ||
                            "Unexpected server error."
                    }
                ]
            };
        }
    };


    const processBulkUploadResults = async (files) => {

        const successful = [];
        const failed = [];

        let hasSuccessfulUpload = false;

        files.forEach(file => {

            const successResults = [];
            const failedResults = [];

            (file.Results || []).forEach(result => {

                if (result.Success && result.Status === 1) {
                    successResults.push(result);
                    hasSuccessfulUpload = true;
                } else {
                    failedResults.push(result);
                }

            });

            if (successResults.length > 0) {
                successful.push({
                    ...file,
                    Results: successResults
                });
            }

            if (failedResults.length > 0) {
                failed.push({
                    ...file,
                    Results: failedResults
                });
            }

        });

        // Existing reference upload
        if (
            AppContext.currentReference &&
            hasSuccessfulUpload
        ) {
            AppContext.setReferences(list =>
                list.map(item =>
                    item.Id === AppContext.currentReference.Id
                        ? { ...item, HasPDF: 1 }
                        : item
                )
            );

            await AppContext.loadReferenceDetails(
                AppContext.currentReference.Id
            );
        }

        setUploadResults({
            successful,
            failed
        });

        console.log({
            successful,
            failed
        });
    };


    const handleSubmit = async (e, filetype) => {
        e.preventDefault();

        setStartedUploading(true);
        setConcludedUploads(0);
        setShowCloseAndRefreshListButton(false);
        setUploadResults(null);

        const uploads = await Promise.allSettled(
            selectedValidFiles.map((file, index) =>
                uploadFile(file, index, filetype)
            )
        );

        const results = uploads.map((upload, index) => {

            if (upload.status === "fulfilled") {
                return upload.value;
            }

            return {
                Success: false,
                FileName: selectedValidFiles[index].name,
                Results: [
                    {
                        Success: false,
                        ReferenceId: null,
                        Status: -1,
                        Message: "Upload failed."
                    }
                ]
            };

        });

        await processBulkUploadResults(results);

        setShowCloseAndRefreshListButton(true);
    };




    // When all the uploads are complete show button to close and refresh the main list

    useEffect(() => {

        if (selectedValidFiles.length > 0) {
            if (concludedUploads == selectedValidFiles.length) {
                setShowCloseAndRefreshListButton(true);
            }
        }

    }, [concludedUploads]);



    const closeAndRefreshList = () => {
        AppContext.showAddFilePopup(false);
        AppContext.refreshList();
    }







    let fileUploadsCompleted = uploadProgress.filter((item) => item == 100).length;


    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    

    const addManualReference = () => {

        setAddReferenceError(false);

        // Validations

        let isValidForm = true;

        setErrorAddReferenceTitle(false);
        setErrorAddReferenceAbstract(false);
        setErrorAddReferenceAuthors(false);
        setErrorAddReferenceSource(false);
        setErrorAddReferenceYear(false);

        if (!validFormField(addReferenceTitle, setErrorAddReferenceTitle)) isValidForm = false;
        if (!validFormField(addReferenceAuthors, setErrorAddReferenceAuthors)) isValidForm = false;
        if (!validFormField(addReferenceSource, setErrorAddReferenceSource)) isValidForm = false;
        if (!validFormField(addReferenceYear, setErrorAddReferenceYear)) isValidForm = false;

        if (!isValidForm) return false;

        let addReferenceAPIURL = "/umbraco/api/ReferenceManager/Reference";

        let newReference = {
            Title: addReferenceTitle,
            Abstract: addReferenceAbstract,
            Authors: addReferenceAuthors,
            Journal: addReferenceJournal,
            Source: addReferenceSource,
            Doi: addReferenceDOI,
            Url: addReferenceURL,
            PublicationType: addReferencePublicationType,
            PublicationDate: addReferencePublicationDate,
            Keywords: addReferenceKeywords,
            Language: addReferenceLanguage,
            VolumeNumber: addReferenceVolume,
            IssueNumber: addReferenceIssue,
            Pages: addReferencePages,
            ISSN: addReferenceISSN
        };

        // Update year value

        let date = new Date(addReferenceYear);
        let year = date.getFullYear();

        newReference.Year = year;


        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newReference)
        };


        setIsAddingReference(true);

        fetch(addReferenceAPIURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data.Id) {
                    let newReferencesList = [data, ...AppContext.references];

                    AppContext.setReferences(newReferencesList);

                    setAddReferenceTitle("");
                    setAddReferenceAbstract("");
                    setAddReferenceAuthors("");
                    setAddReferenceJournal("");
                    setAddReferenceSource("");
                    setAddReferenceDOI("");
                    setAddReferenceURL("");
                    setAddReferencePublicationType("");
                    setAddReferenceYear("");
                    setAddReferencePublicationDate("");
                    setAddReferenceKeywords("");
                    setAddReferenceLanguage("");
                    setAddReferenceVolume("");
                    setAddReferenceIssue("");
                    setAddReferencePages("");
                    setAddReferenceISSN("");

                    setSearchDOI("");

                    setIsShowingSaveMessage(true);

                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setAddReferenceError(true);
            })
            .finally(() => {
                setIsAddingReference(false);
            });

    }



    function decodeHtmlEntities(str) {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    }


    function getPublicationType(type) {

        return new Promise((resolve, reject) => {

            let url = "https://api.crossref.org/types/" + type;

            const requestOptions = {
                method: "GET",
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        reject("");
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then(async (data) => {

                    if (data.message)
                        resolve(data.message.label);
                
                })
                .catch((error) => {
                    reject("");
                })
                .finally(() => {
                });

        });

    }



    const searchInfoForDOI = () => {

        
        setIsSearchingInfoForDOI(true);

        let url = "https://api.crossref.org/works/" + searchDOI;

        const requestOptions = {
            method: "GET",
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setErrorGettingDOIInfo(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then(async (data) => {

                if (data.message) {

                    data = data.message;

                    const title = data.title?.[0] || "";
                    const abstract = data.abstract?.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim() || ""; // strip JATS XML tags
                    let authors = data.author
                        ? data.author
                            .map(a => `${a.given || ""} ${a.family || ""}`.trim())
                            .join(", ")
                        : "";
                    const journal = decodeHtmlEntities(data["container-title"]?.[0] || "");
                    const source = data.publisher || "";
                    const DOI = data.DOI || "";
                    const url = data.resource?.primary?.URL || data.URL || "";

                    let year = "";
                    try {

                        let yearPart = data.published?.["date-parts"]?.[0]?.[0];
                        let monthPart = data.published?.["date-parts"]?.[0]?.[1] || 1;
                        let dayPart = data.published?.["date-parts"]?.[0]?.[2] || 1;

                        year = new Date(yearPart + "-" + monthPart + "-" + dayPart);
                    }
                    catch (ex) {}
                    
                    let publicationType = await getPublicationType(data.type);


                    let publicationDate = "";
                    try {

                        let yearPart = data.published?.["date-parts"]?.[0]?.[0];
                        let monthPart = data.published?.["date-parts"]?.[0]?.[1] || 1;
                        let dayPart = data.published?.["date-parts"]?.[0]?.[2] || 1;

                        publicationDate = new Date(yearPart + "-" + monthPart + "-" + dayPart);
                    }
                    catch (ex) {}

                    const keywords = data.subject?.join(", ") || ""; // may be empty

                    const volume = data.volume || "";
                    const issue = data.issue || "";
                    const pages = data.page || "";
                    const ISSN = data.ISSN?.[0] || "";
                    let display = new Intl.DisplayNames(['en'], { type: 'language' });
                    let language = "";
                    try {
                        language = display.of(data.language);
                    }
                    catch (ex) { }
                    


                    setAddReferenceTitle(title);
                    setAddReferenceAbstract(abstract);
                    setAddReferenceAuthors(authors);
                    setAddReferenceJournal(journal);
                    setAddReferenceSource(source);
                    setAddReferenceDOI(DOI);
                    setAddReferenceURL(url);
                    setAddReferenceYear(year);
                    setAddReferencePublicationType(publicationType);
                    setAddReferencePublicationDate(publicationDate);
                    setAddReferenceKeywords(keywords);
                    setAddReferenceLanguage(language);
                    setAddReferenceVolume(volume);
                    setAddReferenceIssue(issue);
                    setAddReferencePages(pages);
                    setAddReferenceISSN(ISSN);

                }
                
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSearchingInfoForDOI(false);
            });

    }





    useEffect(() => {

        setSelectedFiles([]);
        setSelectedValidFiles([]);
        setInvalidFilesSelected(false);

    }, [selectedOption]);






    return (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>

            {!showPDFOnly && 

                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "row",
                        marginBottom: "15px"
                    }}>

                    <div
                        style={{
                            cursor: "pointer",
                            paddingBottom: "3px",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            ...(selectedOption == "manual"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => setSelectedOption("manual")}
                    >
                        <i className="fas fa-pen g-mr-5"></i> Manually Add Reference
                    </div>

                    <div
                        style={{
                            cursor: "pointer",
                            paddingBottom: "3px",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            ...(selectedOption == "pdf"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => setSelectedOption("pdf")}
                    >
                        <i className="fas fa-file-pdf g-mr-5"></i> Upload PDFs
                    </div>

                    <div
                        style={{
                            cursor: "pointer",
                            paddingBottom: "3px",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            ...(selectedOption == "ris"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => setSelectedOption("ris")}
                    >
                        <i className="fas fa-file-alt g-mr-5"></i> Upload RIS Library
                    </div>

                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

                </div>

            }



            <div style={{marginTop: "20px"}}>

                {selectedOption == "pdf" &&
                    <div>

                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        {warningMessage && <p style={{ color: 'orange' }}>{warningMessage}</p>}

                        <form onSubmit={(e) => handleSubmit(e, "pdf")} style={{ display: "flex", justifyContent: "center", flexDirection: "column", }}>
                            <div style={{ width: "100%", textAlign: "center"}}>
                                <label
                                    style={{ width: "200px", textAlign: "center", marginBottom: "20px", cursor: "pointer", fontSize: "1.1em", padding: "4px 15px", backgroundColor: "", border: "1px solid black", borderRadius: "15px" }}
                                    id="file-input-label"
                                    onClick={() => pdfFileInputRef.current.click()}
                                >
                                    Select your PDF file{!showPDFOnly ? "(s)" : ""}
                                </label>

                                <input
                                    id="file-input"
                                    type="file"
                                    title=""
                                    multiple={allowMultiple}
                                    ref={pdfFileInputRef}
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                    accept=".pdf,application/pdf"
                                />
                            </div>


                            
                            {invalidFilesSelected && (
                                <div
                                    style={{ border: "1px solid #f3b2b2", borderRadius: 6, padding: 12, marginBottom: 12, background: "#fff5f5", }}
                                >
                                    <div style={{ fontWeight: 600, color: "#c62828", marginBottom: 8, }} >
                                        Invalid file type
                                    </div>

                                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                                        <li style={{ color: "#b71c1c", marginBottom: 4, }}>
                                            One or more selected files are not in <strong>.pdf</strong> format.
                                            Please select only <strong>.pdf</strong> files and try again.
                                        </li>
                                    </ul>
                                </div>
                            )}


                            {/* Are there any selected files for upload? */}

                            {selectedFiles.length > 0 && (
                                <div>
                                    <h3 style={{ marginBottom: "12px", color: "#555" }}>
                                        Selected File{!showPDFOnly ? "s" : ""}:
                                    </h3>

                                    <div className="thin-scrollbar" style={{ maxHeight: "100px", overflowY: "auto", border: "1px solid #ddd", borderRadius: "6px", padding: "8px", backgroundColor: "#fafafa", }}>
                                        {selectedFiles.map((file, index) => (
                                            <div key={index} style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: index === selectedFiles.length - 1 ? 0 : "8px", }}>
                                                <div title={file.name} style={{ flex: 1, minWidth: 0, color: "#555", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                    {file.name}
                                                </div>

                                                <div style={{ width: "250px", flexShrink: 0 }}>
                                                    {startedUploading ?
                                                        <ProgressBar now={uploadProgress[index]} label={`${uploadProgress[index]}%`} />
                                                        :
                                                        <div style={{ height: "15px",  fontSize: "0.75rem",  width: "100%",  backgroundColor: "#dff8ff",  textAlign: "center",  borderRadius: "3px", }}>
                                                            Ready to start uploading
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ marginTop: "20px" }}>

                                        {!startedUploading ? <>

                                            <button className="action-button add-task-button" type="submit">Upload File{!showPDFOnly ? "s" : null}</button>

                                        </> : <>
                                            {/* If the upload has started show progress */}
                                            {/* Check if all files are 100% uploaded */}

                                            {fileUploadsCompleted == uploadProgress.length ?
                                                <>
                                                    {showPDFOnly ? "File uploaded. Processing..." : "All files uploaded. Processing..."}
                                                    <br /><br />


                                                        {uploadResults?.failed?.length > 0 && (
                                                            <>
                                                                <h3 style={{ color: "#c62828", marginBottom: 12 }}>
                                                                    Failed
                                                                </h3>

                                                                {uploadResults.failed.map((file, index) => (
                                                                    <div
                                                                        key={`failed-${index}`}
                                                                        style={{
                                                                            border: "1px solid #f3b2b2",
                                                                            borderRadius: 6,
                                                                            padding: 12,
                                                                            marginBottom: 12,
                                                                            background: "#fff5f5"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                marginBottom: 8
                                                                            }}
                                                                        >
                                                                            {file.FileName}
                                                                        </div>

                                                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                                            {file.Results.map((result, i) => (
                                                                                <li
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: "#b71c1c",
                                                                                        marginBottom: 4
                                                                                    }}
                                                                                >
                                                                                    {result.Message}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}


                                                        {uploadResults?.successful?.length > 0 && (
                                                            <>
                                                                <h3 style={{ color: "#2e7d32", marginBottom: 12 }}>
                                                                    Successful
                                                                </h3>

                                                                {uploadResults.successful.map((file, index) => (
                                                                    <div
                                                                        key={`success-${index}`}
                                                                        style={{
                                                                            border: "1px solid #b8e6c2",
                                                                            borderRadius: 6,
                                                                            padding: 12,
                                                                            marginBottom: 12,
                                                                            background: "#f6fff7"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                marginBottom: 8
                                                                            }}
                                                                        >
                                                                            {file.FileName}
                                                                        </div>

                                                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                                            {file.Results.map((result, i) => (
                                                                                <li
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: "#1b5e20",
                                                                                        marginBottom: 4
                                                                                    }}
                                                                                >
                                                                                    {result.Message}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}




                                                    {uploadResults && !showPDFOnly && 
                                                        <button className="action-button cancel-button" type="button" onClick={closeAndRefreshList}>Close and refresh list</button>
                                                    }

                                                    
                                                </> : <>

                                                        {!showPDFOnly &&
                                                            <>
                                                                Files uploaded: {fileUploadsCompleted} of {uploadProgress.length}
                                                            </>    
                                                        }
                                                </>
                                            }
                                        </>}

                                    </div>
                        

                                </div>
                            )}

                        </form>

                    </div>
                }



                {selectedOption == "manual" &&

                    <div>
                        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", marginBottom: "30px" }}>
                                <div style={{
                                    width: "350px",
                                    padding: "10px 12px 14px",
                                    borderRadius: "10px",
                                    background: "linear-gradient(145deg, #f7f7f7, #eaeaea)",
                                    border: "1px solid #ccc",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
                                }}>
                                    <div style={{ textAlign: "center", marginBottom: "8px" }}>
                                        Retrieve the Article information using the DOI:
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <input
                                            type="text"
                                            value={searchDOI}
                                            onChange={(e) => { setErrorGettingDOIInfo(false); setSearchDOI(e.target.value); }}
                                            placeholder="DOI"
                                            style={{
                                                width: "280px",
                                                padding: "6px 8px",
                                                border: "1px solid #bbb",
                                                borderRadius: "10px",
                                                outline: "none",
                                                transition: "border-color 0.2s"
                                            }}
                                            onFocus={(e) => e.currentTarget.style.borderColor = "#0078d7"}
                                            onBlur={(e) => e.currentTarget.style.borderColor = "#bbb"}
                                        />
                                        <span style={{ marginLeft: "3px", display: "flex", alignItems: "center" }}>
                                            {isSearchingInfoForDOI && <LoadingSpinnerImage />}
                                            {!isSearchingInfoForDOI && (
                                                <>
                                                    {errorGettingDOIInfo ? (
                                                        <i
                                                            className="fas fa-exclamation-circle"
                                                            title="Error loading DOI information"
                                                            style={{ color: "red", marginRight: "5px" }}
                                                        ></i>
                                                    ) : (
                                                        <button
                                                            onClick={searchInfoForDOI}
                                                            style={{
                                                                padding: "4px 8px",
                                                                border: "none",
                                                                backgroundColor: "rgb(0, 120, 215)",
                                                                color: "white",
                                                                borderRadius: "10px",
                                                                fontSize: "13px",
                                                                cursor: "pointer",
                                                                transition: "background-color 0.2s"
                                                            }}
                                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#005fa3"}
                                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#0078d7"}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <input className={`form-field-text add-task-field-name ${errorAddReferenceTitle ? " form-field-error" : null}`}
                            value={addReferenceTitle}
                            onChange={(e) => setAddReferenceTitle(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Title *" />
                        <br /><br />
                        <textarea className={`form-field-text add-task-field-name ${errorAddReferenceAbstract ? " form-field-error" : null}`}
                            value={addReferenceAbstract}
                            onChange={(e) => setAddReferenceAbstract(e.target.value)}
                            style={{ width: "100%" }} placeholder="Abstract" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceAuthors ? " form-field-error" : null}`}
                            value={addReferenceAuthors}
                            onChange={(e) => setAddReferenceAuthors(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Authors *" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceJournal ? " form-field-error" : null}`}
                            value={addReferenceJournal}
                            onChange={(e) => setAddReferenceJournal(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Journal" />
                        <br /><br />

                        <input className={`form-field-text add-task-field-name ${errorAddReferenceVolume ? " form-field-error" : null}`}
                            value={addReferenceVolume}
                            onChange={(e) => setAddReferenceVolume(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Volume" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceIssue ? " form-field-error" : null}`}
                            value={addReferenceIssue}
                            onChange={(e) => setAddReferenceIssue(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Issue" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferencePages ? " form-field-error" : null}`}
                            value={addReferencePages}
                            onChange={(e) => setAddReferencePages(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Pages" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceISSN ? " form-field-error" : null}`}
                            value={addReferenceISSN}
                            onChange={(e) => setAddReferenceISSN(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="ISSN" />
                        <br /><br />


                        <input className={`form-field-text add-task-field-name ${errorAddReferenceSource ? " form-field-error" : null}`}
                            value={addReferenceSource}
                            onChange={(e) => setAddReferenceSource(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Source *" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceDOI ? " form-field-error" : null}`}
                            value={addReferenceDOI}
                            onChange={(e) => setAddReferenceDOI(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="DOI" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceURL ? " form-field-error" : null}`}
                            value={addReferenceURL}
                            onChange={(e) => setAddReferenceURL(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="URL" />
                        <br /><br />
                        <DatePicker
                            className={`datepicker-field add-task-field-date-start ${errorAddReferenceYear ? "form-field-error" : null}`}
                            dateFormat="yyyy"
                            showYearPicker
                            placeholderText="Year *"
                            selected={addReferenceYear}
                            onChange={(date) => {
                                setAddReferenceYear(date);
                            }}
                            popperPlacement={datePopperConfig.placement}
                            popperModifiers={datePopperConfig.modifiers}
                        />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferencePublicationType ? " form-field-error" : null}`}
                            value={addReferencePublicationType}
                            onChange={(e) => setAddReferencePublicationType(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Publication Type" />
                        <br /><br />
                        <DatePicker
                            title="Publication Date"
                            className={`datepicker-field add-task-field-date-start ${errorAddReferencePublicationDate ? "form-field-error" : null}`}
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Publication Date"
                            selected={addReferencePublicationDate}
                            onChange={(date) => {
                                setAddReferencePublicationDate(date);
                            }}
                            popperPlacement={datePopperConfig.placement}
                            popperModifiers={datePopperConfig.modifiers}
                        />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceKeywords ? " form-field-error" : null}`}
                            value={addReferenceKeywords}
                            onChange={(e) => setAddReferenceKeywords(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Keywords" />
                        <br /><br />
                        <input className={`form-field-text add-task-field-name ${errorAddReferenceLanguage ? " form-field-error" : null}`}
                            value={addReferenceLanguage}
                            onChange={(e) => setAddReferenceLanguage(e.target.value)}
                            style={{ width: "100%" }} type="text" placeholder="Language" />
                        


                        <br /><br />
                        <span style={{ fontSize: "0.8rem", color: "#888" }} >* Mandatory fields</span>
                        <br /><br />

                        {isAddingReference ? <>
                            <LoadingSpinnerImage />
                        </> : <>
                            <button className="action-button add-task-button" style={{ marginRight: "15px" }} type="button" onClick={() => addManualReference()}>Add Reference</button>
                        </>

                        }



                        <span
                            className={`${isShowingSaveMessage
                                ? "save-message-shown"
                                : "save-message-hidden"
                                }`}
                            onTransitionEnd={() => setIsShowingSaveMessage(false)}
                        >
                            Add successful!
                        </span>



                        {addReferenceError && <div>
                            An error ocurred when adding the reference
                        </div>}

                    </div>
                }



                {selectedOption == "ris" &&

                    <div>

                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        {warningMessage && <p style={{ color: 'orange' }}>{warningMessage}</p>}
                    
                        <form onSubmit={(e) => handleSubmit(e, "ris")} style={{ display: "flex", justifyContent: "center", flexDirection: "column", }}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <label
                                style={{ width: "200px", textAlign: "center", marginBottom: "20px", cursor: "pointer", fontSize: "1.1em", padding: "4px 15px", backgroundColor: "", border: "1px solid black", borderRadius: "15px" }}
                                id="file-input-label"
                                onClick={() => risFileInputRef.current.click()}
                                >
                                Select your RIS file(s)
                            </label>

                            <input
                                id="file-input"
                                type="file"
                                title=""
                                multiple
                                ref={risFileInputRef}
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                accept=".ris"
                            />
                        </div>



                            {invalidFilesSelected && (
                                <div style={{ border: "1px solid #f3b2b2", borderRadius: 6, padding: 12, marginBottom: 12, background: "#fff5f5", }}>
                                    <div style={{ fontWeight: 600, color: "#c62828", marginBottom: 8, }}>
                                        Invalid file type
                                    </div>

                                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                                        <li style={{ color: "#b71c1c", marginBottom: 4, }}>
                                            One or more selected files are not in <strong>.ris</strong> format.
                                            Please select only <strong>.ris</strong> files and try again.
                                        </li>
                                    </ul>
                                </div>
                            )}


                        {/* Are there any selected files for upload? */}

                        {selectedFiles.length > 0 && (
                            <div>
                                <h3>Selected Files:</h3>
                                <div className="thin-scrollbar" style={{ maxHeight: "100px", overflowY: "auto", border: "1px solid #ddd", borderRadius: "6px", padding: "8px", backgroundColor: "#fafafa", }}>
                                    {selectedFiles.map((file, index) => (
                                        <div key={index} style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: index === selectedFiles.length - 1 ? 0 : "8px", }}>
                                            <div title={file.name} style={{ flex: 1, minWidth: 0, color: "#555", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                {file.name}
                                            </div>

                                            <div style={{ width: "250px", flexShrink: 0 }}>
                                                {startedUploading ?
                                                    <ProgressBar now={uploadProgress[index]} label={`${uploadProgress[index]}%`} />
                                                    :
                                                    <div style={{ height: "15px",  fontSize: "0.75rem",  width: "100%",  backgroundColor: "#dff8ff",  textAlign: "center",  borderRadius: "3px", }}>
                                                        Ready to start uploading
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ marginTop: "20px" }}>

                                    {!startedUploading ? <>

                                        <button className="action-button add-task-button" type="submit">Upload Files</button>

                                    </> : <>
                                        {/* If the upload has started show progress */}
                                        {/* Check if all files are 100% uploaded */}

                                        {fileUploadsCompleted == uploadProgress.length ?
                                            <>

                                                {showPDFOnly ? "File uploaded. Processing..." : "All files uploaded. Processing..."}
                                                <br /><br />


                                                
                                                    
                                                        {uploadResults?.failed?.length > 0 && (
                                                            <>
                                                                <h3 style={{ color: "#c62828", marginBottom: 12 }}>
                                                                    Failed
                                                                </h3>

                                                                {uploadResults.failed.map((file, index) => (
                                                                    <div
                                                                        key={`failed-${index}`}
                                                                        style={{
                                                                            border: "1px solid #f3b2b2",
                                                                            borderRadius: 6,
                                                                            padding: 12,
                                                                            marginBottom: 12,
                                                                            background: "#fff5f5"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                marginBottom: 8
                                                                            }}
                                                                        >
                                                                            {file.FileName}
                                                                        </div>

                                                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                                            {file.Results.map((result, i) => (
                                                                                <li
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: "#b71c1c",
                                                                                        marginBottom: 4
                                                                                    }}
                                                                                >
                                                                                    {result.Message}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}


                                                        {uploadResults?.successful?.length > 0 && (
                                                            <>
                                                                <h3 style={{ color: "#2e7d32", marginBottom: 12 }}>
                                                                    Successful
                                                                </h3>

                                                                {uploadResults.successful.map((file, index) => (
                                                                    <div
                                                                        key={`success-${index}`}
                                                                        style={{
                                                                            border: "1px solid #b8e6c2",
                                                                            borderRadius: 6,
                                                                            padding: 12,
                                                                            marginBottom: 12,
                                                                            background: "#f6fff7"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                marginBottom: 8
                                                                            }}
                                                                        >
                                                                            {file.FileName}
                                                                        </div>

                                                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                                            {file.Results.map((result, i) => (
                                                                                <li
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: "#1b5e20",
                                                                                        marginBottom: 4
                                                                                    }}
                                                                                >
                                                                                    {result.Message}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}





                                                {uploadResults && !showPDFOnly &&
                                                    <button className="action-button cancel-button" type="button" onClick={closeAndRefreshList}>Close and refresh list</button>
                                                        }



                                            </> : <>
                                                Files uploaded: {fileUploadsCompleted} of {uploadProgress.length}
                                            </>
                                        }
                                    </>}

                                </div>


                            </div>
                        )}

                    </form>
                        
                    </div>

                }

            </div>


            
        </div>
    );
}

export default MultipleFileUpload;
